module.exports = __webpack_public_path__ + "img/icb-empty-Adv-m@3x.b4efdb1c.png";